export const MODALIDAD_PROGRAMA_CLAVE_ESPECIALIDADES_MEDICAS = 'ESP MED';
export const ALUMNOS_CLAVE_ACTA_NO = '2';

/**
 * Constantes para determinar la cantidad de años asignables de vigencias para programas SNP.
 * Se usa en el componente: cuestionario-snp.component.ts
 */
export const VIGENCIA_PROGRAMA_SI_ACREDITADO = 3;
export const VIGENCIA_PROGRAMA_NO_ACREDITADO = 0;

export const APROBAO = 'Aprobado';
export const NO_APROBADO = 'No aprobado';
